export default function Hero() {
  const handleCTA = () => {
    const ofertaSection = document.getElementById('oferta-especial');
    ofertaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/9423d153e6c1f4fd53c21de04be414e3/678c06ccf3b8691b0957a698c500cab6.png"
          alt="Mesa Boogie Triple Rectifier"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-20 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/9423d153e6c1f4fd53c21de04be414e3/d769c3a89009f6eb395209919ee5a6de.png"
            alt="Ampero II Captures Tomcore"
            className="w-full max-w-4xl h-auto"
          />
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight leading-tight">
          High Gain Real. Brutal.<br />
          <span className="text-orange-500">Pronto pra palco e estúdio.</span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Captures profissionais criadas por Tom Chagas para Ampero II Stage, MP350 e Stomp II.<br />
          <strong className="text-white">Peso, definição e resposta real</strong> — sem presets genéricos.
        </p>

        {/* CTA Button */}
        <button
          onClick={handleCTA}
          className="group relative inline-flex items-center justify-center px-12 py-6 text-xl font-black text-black bg-orange-500 hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer mb-16"
        >
          <i className="ri-fire-fill mr-3 text-2xl"></i>
          QUERO MEU CAPTURE AGORA
          <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 text-sm text-orange-400 font-bold whitespace-nowrap">
            Download imediato
          </div>
        </button>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-4xl text-orange-500"></i>
        </div>
      </div>
    </section>
  );
}
